<!--
/**
* @name: YImage.vue
* @description: 图片预览
* @author: 于海威
* @create: 2020/08/13 15:23:59
* @update: 2020/08/13 15:23:59
*/
-->

<template>
  <div>
    <div :class="css.img_box">
      <img :src="src" :title="title" @click="onPreview(src)" />
      <span :class="css.action" v-if="!view">
        <k-icon name="icon-shanchu" @click="onDelete"></k-icon>
      </span>
    </div>
    <k-popup bind="v-if" title="查看大图" :show.sync="isPopupShow" layout="header,body,close,mask">
      <div style="width: 650px; text-align: center;">
        <img :src="src" :title="title" style="height: 100%;" />
      </div>
    </k-popup>
  </div>
</template>

<script>
const defaultImg = require("@/assets/images/goods-img.png");

export default {
  props: {
    src: {
      type: String,
      default: "",
    },
    title: String,
    index: {
      type: Number,
      default: 0,
    },
    view: {
      type: Boolean,
      default: false,
    },
  },
  watch: {},
  data() {
    return {
      isPopupShow: false,
    };
  },
  methods: {
    onDelete() {
      const { index, src } = this.$props;
      this.$emit("delete", { index, src });
    },
    //查看大图
    onPreview(src) {
      if (src != defaultImg) {
        this.isPopupShow = true;
      }
    },
  },
  created() {
    if (!this.src) {
      this.src = defaultImg;
    }
  },
};
</script>

<style lang="postcss" module="css">
.img_box {
  width: 120px;
  height: 120px;
  overflow: hidden;
  position: relative;
  border-radius: 4px;
  border: solid 1px var(--color-border);
  display: inline-block;
  margin-left: 10px;
  & img {
    max-width: 100%;
    height: 100%;
    min-width: 100%;
    cursor: pointer;
  }
  & .action {
    position: absolute;
    left: 0;
    right: 0;
    bottom: -100%;
    line-height: 24px;
    text-align: center;
    color: #fff;
    background: rgba(0, 0, 0, 0.3);
    transition: bottom 0.3s ease-out;
  }
  &:hover .action {
    bottom: 0;
    transition: bottom 0.3s linear;
  }
  & .action :global(.iconfont) {
    cursor: pointer;
  }
}
</style>
